import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';

const PaymentCancel = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-[#FAF8F5] pt-28 pb-16 flex items-center justify-center">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-md mx-auto text-center px-4">
        <div className="w-20 h-20 mx-auto mb-6 border border-red-400/40 flex items-center justify-center">
          <XCircle className="w-10 h-10 text-red-400" />
        </div>
        <h1 className="font-['Playfair_Display'] text-3xl font-bold text-[#283880] tracking-tight mb-3">
          {t('ui.payment.cancelTitle')}
        </h1>
        <p className="text-[#5A6578] mb-8 leading-relaxed">
          {t('ui.payment.cancelText')}
        </p>
        <Link to="/area-clienti">
          <Button className="bg-[#283880] hover:bg-[#1B275B] text-white rounded-none uppercase tracking-[0.15em] text-[10px] font-bold h-12 px-8">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('ui.payment.back')}
          </Button>
        </Link>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;
